<main>
    <div
        style="
            height: calc(100% - 64px);
            box-shadow: 0 3px 8px rgb(20 20 20 / 18%);
            border-radius: 5px 0 0 5px;
            overflow: auto;
            background: #fff;
        "
    >
        <div class="content" style="padding: 20px">
            <div>
                <div>{{ "MENU.ACCOUNT_INFO" | translate }}</div>
                <div class="user-field">
                    <div style="margin-bottom: 8px">
                        <label class="input-label" for="name">{{
                            "GLOBAL.USERNAME" | translate
                        }}</label>
                        <div style="font-size: 16px; line-height: 22px">
                            {{ userProfile?.username }}
                        </div>
                    </div>
                    <div *ngIf="userProfile?.position == 'BRANCH'">
                        <div style="margin-bottom: 8px">
                            <label class="input-label" for="name"
                                >Branch code</label
                            >
                            <div style="font-size: 16px; line-height: 22px">
                                {{ userProfile?.branch.code }}
                            </div>
                        </div>
                        <div style="margin-bottom: 8px">
                            <label class="input-label" for="name"
                                >Branch name</label
                            >
                            <div style="font-size: 16px; line-height: 22px">
                                {{ userProfile?.branch.name[selectedLang] }}
                            </div>
                        </div>
                    </div>
                    <div
                        class="change"
                        style="margin-bottom: 20px"
                        (click)="openChangePass()"
                    >
                        <div
                            style="
                                display: flex;
                                align-items: center;
                                margin-top: 20px;
                            "
                        >
                            <div style="margin-right: 4px">
                                <mat-icon class="pass-icon">lock</mat-icon>
                            </div>
                            <div style="font-size: 14px">
                                {{ "GLOBAL.CHANGE_PASS" | translate }}
                            </div>
                            <!-- <mat-icon class="pass-icon" svgIcon="passWord"></mat-icon> -->
                            <!-- {{ "PASSWORD.CHANGE_PASSWORD" | translate }} -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div>
        <div>Branch information</div>
        <div class="user-field">
          <div>
            <label class="input-label" for="name">{{ 'FOOD.BRANCH_CODE' | translate }}</label>
            <div style="font-size: 16px; line-height: 22px">ninebranch04</div>
          </div>
          <div>
            <label class="input-label" for="name">Branch Thai</label>
            <div style="font-size: 16px; line-height: 22px">ninebranch04</div>
          </div>
          <div>
            <label class="input-label" for="name">Branch English</label>
            <div style="font-size: 16px; line-height: 22px">ninebranch04</div>
          </div>
          <div>
            <label class="input-label" for="name">Name</label>
            <div style="font-size: 16px; line-height: 22px">ninebranch04</div>
          </div>
          <div>
            <label class="input-label" for="name">Email</label>
            <div style="font-size: 16px; line-height: 22px">ninebranch04</div>
          </div>
          <div>
            <label class="input-label" for="name">Phone number</label>
            <div style="font-size: 16px; line-height: 22px">ninebranch04</div>
          </div>
        </div>
      </div>
      <div>
        <div>History information</div>
        <div class="user-field">
          <div>
            <label class="input-label" for="name">Login</label>
            <div style="font-size: 16px; line-height: 22px">ninebranch04</div>
          </div>
          <div>
            <label class="input-label" for="name">Logout</label>
            <div style="font-size: 16px; line-height: 22px">ninebranch04</div>
          </div>
        </div>
      </div> -->
        </div>
        <ng-template #changePassDialog style="padding: 30px">
            <form
                [formGroup]="passForm"
                #cngPassForm="ngForm"
                (ngSubmit)="onChangePassword()"
            >
                <div
                    class="sep-h"
                    style="
                        margin: 0;
                        font-size: 18px;
                        line-height: 24px;
                        font-weight: 600;
                    "
                >
                    {{ "GLOBAL.CHANGE_PASS" | translate }}
                </div>
                <div class="error-pc" *ngIf="errorCode">
                    <span class="error-ps">{{ errorMsg }}</span>
                </div>
                <mat-dialog-content>
                    <div style="margin-top: 20px">
                        <label
                            for=""
                            style="
                                font-size: 12px;
                                line-height: 16px;
                                margin-bottom: 4px !important;
                            "
                            >{{ "GLOBAL.CURRENT_PASSWORD" | translate }}</label
                        >
                        <div
                            class="input-group"
                            style="margin-bottom: 20px; margin-top: 4px"
                        >
                            <div
                                class="user-addon"
                                [class.is-invalid]="
                                    (cngPassForm.submitted &&
                                        passForm.get('oldPassword')?.invalid) ||
                                    (passForm.get('oldPassword').touched &&
                                        passForm.get('oldPassword')?.invalid) ||
                                    errorCode == 109
                                "
                                #myIdentifier
                            >
                                <mat-icon
                                    [class.is-invalid]="
                                        (cngPassForm.submitted &&
                                            passForm.get('oldPassword')
                                                ?.invalid) ||
                                        (passForm.get('oldPassword').touched &&
                                            passForm.get('oldPassword')
                                                ?.invalid) ||
                                        errorCode == 109
                                    "
                                    class="pass-icon-e"
                                    svgIcon="lock"
                                ></mat-icon>
                            </div>
                            <input
                                formControlName="oldPassword"
                                [type]="showPassC1 ? 'text' : 'password'"
                                [ngStyle]="{
                                    'padding-left.px':
                                        myIdentifier.offsetWidth + 12
                                }"
                                style="padding-left: 105px !important"
                                class="input-all form-control"
                                [class.is-invalid]="
                                    (cngPassForm.submitted &&
                                        passForm.get('oldPassword')?.invalid) ||
                                    (passForm.get('oldPassword').touched &&
                                        passForm.get('oldPassword')?.invalid) ||
                                    errorCode == 109
                                "
                            />
                            <div
                                class="pass-addon"
                                (click)="showPassC1 = !showPassC1"
                            >
                                <mat-icon
                                    *ngIf="!showPassC1"
                                    class="eye-icon"
                                    svgIcon="eye-open"
                                ></mat-icon>
                                <mat-icon
                                    *ngIf="showPassC1"
                                    class="eye-icon"
                                    svgIcon="eye-close"
                                ></mat-icon>
                            </div>
                            <div class="input-error">
                                <img
                                    src="../../assets/icons/input-warning.svg"
                                    style="
                                        width: 16px;
                                        height: 16px;
                                        margin-right: 4px;
                                    "
                                />{{ "GLOBAL.EN_CURRENT_PASSWORD" | translate }}
                            </div>
                        </div>
                        <label
                            for=""
                            style="
                                font-size: 12px;
                                line-height: 16px;
                                margin-bottom: 4px !important;
                            "
                            >{{ "GLOBAL.NEW_PASS" | translate }}</label
                        >
                        <div
                            class="input-group"
                            style="margin-bottom: 20px; margin-top: 4px"
                        >
                            <div
                                class="user-addon"
                                [class.valid]="
                                    passForm.get('newPassword')?.valid
                                "
                                [class.is-invalid]="
                                    (cngPassForm.submitted &&
                                        passForm.get('newPassword')?.invalid) ||
                                    (passForm.get('newPassword').touched &&
                                        passForm.get('newPassword')?.invalid)
                                "
                                #myIdentifier
                            >
                                <mat-icon
                                    [class.valid]="
                                        passForm.get('newPassword')?.valid
                                    "
                                    [class.is-invalid]="
                                        (cngPassForm.submitted &&
                                            passForm.get('newPassword')
                                                ?.invalid) ||
                                        (passForm.get('newPassword').touched &&
                                            passForm.get('newPassword')
                                                ?.invalid)
                                    "
                                    class="pass-icon-e"
                                    svgIcon="lock"
                                ></mat-icon>
                            </div>
                            <input
                                [type]="showPassC2 ? 'text' : 'password'"
                                [ngStyle]="{
                                    'padding-left.px':
                                        myIdentifier.offsetWidth + 12
                                }"
                                maxlength="16"
                                formControlName="newPassword"
                                [class.is-invalid]="
                                    (cngPassForm.submitted &&
                                        passForm.get('newPassword')?.invalid) ||
                                    (passForm.get('newPassword').touched &&
                                        passForm.get('newPassword')?.invalid)
                                "
                                [class.valid]="
                                    passForm.get('newPassword')?.valid
                                "
                                style="padding-left: 105px !important"
                                class="input-all form-control"
                            />
                            <div
                                class="input-hint"
                                [class.valid]="
                                    passForm.get('newPassword')?.valid
                                "
                                [class.hide-hint]="
                                    (cngPassForm.submitted &&
                                        passForm.get('newPassword')?.invalid) ||
                                    (passForm.get('newPassword').touched &&
                                        passForm.get('newPassword')?.invalid)
                                "
                            >
                                {{ "GLOBAL.PWD_HINT" | translate }}
                            </div>
                            <div
                                class="pass-addon"
                                (click)="showPassC2 = !showPassC2"
                            >
                                <mat-icon
                                    *ngIf="!showPassC2"
                                    class="eye-icon"
                                    svgIcon="eye-open"
                                ></mat-icon>
                                <mat-icon
                                    *ngIf="showPassC2"
                                    class="eye-icon"
                                    svgIcon="eye-close"
                                ></mat-icon>
                            </div>
                            <div
                                class="input-error"
                                *ngIf="
                                    passForm.controls.newPassword.errors
                                        ?.minlength ||
                                    passForm.controls.newPassword.errors
                                        ?.maxlength
                                "
                            >
                                <img
                                    src="../../assets/icons/input-warning.svg"
                                    style="
                                        width: 16px;
                                        height: 16px;
                                        margin-right: 4px;
                                    "
                                />Password must be 8-16 characters long
                            </div>
                            <div
                                class="input-error"
                                *ngIf="
                                    passForm.controls.newPassword.errors
                                        ?.required
                                "
                            >
                                <img
                                    src="../../assets/icons/input-warning.svg"
                                    style="
                                        width: 16px;
                                        height: 16px;
                                        margin-right: 4px;
                                    "
                                />
                                {{ "GLOBAL.EN_NEW_PASSWORD" | translate }}
                            </div>
                        </div>
                        <label
                            for=""
                            style="
                                font-size: 12px;
                                line-height: 16px;
                                margin-bottom: 4px !important;
                            "
                            >{{ "GLOBAL.RE_NEW_PASS" | translate }}</label
                        >
                        <div
                            class="input-group"
                            style="margin-bottom: 28px; margin-top: 4px"
                        >
                            <div
                                class="user-addon"
                                [class.valid]="
                                    passForm.get('confirmNewPwd')?.valid &&
                                    passForm.value.confirmNewPwd ==
                                        passForm.value.newPassword
                                "
                                [class.is-invalid]="
                                    (cngPassForm.submitted &&
                                        passForm.get('confirmNewPwd')
                                            ?.invalid) ||
                                    (passForm.get('confirmNewPwd').touched &&
                                        passForm.get('confirmNewPwd')
                                            ?.invalid) ||
                                    passForm.value.confirmNewPwd !=
                                        passForm.value.newPassword
                                "
                                #myIdentifier
                            >
                                <mat-icon
                                    [class.valid]="
                                        passForm.get('confirmNewPwd')?.valid &&
                                        passForm.value.confirmNewPwd ==
                                            passForm.value.newPassword
                                    "
                                    [class.is-invalid]="
                                        (cngPassForm.submitted &&
                                            passForm.get('confirmNewPwd')
                                                ?.invalid) ||
                                        (passForm.get('confirmNewPwd')
                                            .touched &&
                                            passForm.get('confirmNewPwd')
                                                ?.invalid) ||
                                        passForm.value.confirmNewPwd !=
                                            passForm.value.newPassword
                                    "
                                    class="pass-icon-e"
                                    svgIcon="lock"
                                ></mat-icon>
                            </div>
                            <input
                                [type]="showPassC3 ? 'text' : 'password'"
                                [ngStyle]="{
                                    'padding-left.px':
                                        myIdentifier.offsetWidth + 12
                                }"
                                maxlength="16"
                                [class.is-invalid]="
                                    (cngPassForm.submitted &&
                                        passForm.get('confirmNewPwd')
                                            ?.invalid) ||
                                    (passForm.get('confirmNewPwd').touched &&
                                        passForm.get('confirmNewPwd')
                                            ?.invalid) ||
                                    passForm.value.confirmNewPwd !=
                                        passForm.value.newPassword
                                "
                                [class.valid]="
                                    passForm.get('confirmNewPwd')?.valid &&
                                    passForm.value.confirmNewPwd ==
                                        passForm.value.newPassword
                                "
                                formControlName="confirmNewPwd"
                                style="padding-left: 105px !important"
                                class="input-all form-control"
                            />
                            <div
                                class="pass-addon"
                                (click)="showPassC3 = !showPassC3"
                            >
                                <mat-icon
                                    *ngIf="!showPassC3"
                                    class="eye-icon"
                                    svgIcon="eye-open"
                                ></mat-icon>
                                <mat-icon
                                    *ngIf="showPassC3"
                                    class="eye-icon"
                                    svgIcon="eye-close"
                                ></mat-icon>
                            </div>
                            <div
                                class="input-error"
                                *ngIf="passForm.value.confirmNewPwd == ''"
                            >
                                <img
                                    src="../../assets/icons/input-warning.svg"
                                    style="
                                        width: 16px;
                                        height: 16px;
                                        margin-right: 4px;
                                    "
                                />{{ "GLOBAL.RE_NEW_PASS" | translate }}
                            </div>
                            <div
                                class="input-error"
                                *ngIf="
                                    passForm.value.confirmNewPwd !=
                                        passForm.value.newPassword &&
                                    passForm.value.confirmNewPwd != ''
                                "
                            >
                                <img
                                    src="../../assets/icons/input-warning.svg"
                                    style="
                                        width: 16px;
                                        height: 16px;
                                        margin-right: 4px;
                                    "
                                />Passwords don’t match
                            </div>
                        </div>
                    </div>
                </mat-dialog-content>
                <mat-dialog-actions style="float: left">
                    <div style="justify-content: flex-end; display: flex">
                        <button
                            class="cancel-btn"
                            (click)="closeDialog(); $event.preventDefault()"
                        >
                            Cancel
                        </button>
                        <button class="save-pass" type="submit">
                            {{ "GLOBAL.CHANGE_PASS" | translate }}
                        </button>
                    </div>
                </mat-dialog-actions>
            </form>
        </ng-template>
    </div>
</main>
